import { TranslateService } from '@ngx-translate/core';
import { SessionsService } from '../../../sessions.service';
import { UsersService } from '../../../users/users.service';
import { Component, OnInit } from '@angular/core';
import { WizardService } from '../../../wizard/wizard.service';
import { ISession } from '../../../../../models/session';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'step-generic-login',
  templateUrl: './generic_login.component.html',
  styleUrls: ['../../session-create.component.scss']
})
export class GenericLoginComponent {
  session: ISession;
  models: any = [];
  form = new WizardService().getUniqueLoginSubscription();
  dataForm = this.fb.group({
    login: ['', Validators.required],
    password: ['', Validators.required],
    send_to_all_users: [false, Validators.required]
  });

  constructor(
    private wizardService: WizardService,
    private sessionsService: SessionsService,
    private translate: TranslateService,
    private usersService: UsersService,
    private router: Router,
    private fb: FormBuilder
  ) {}

  save() {
    this.form.next(this.dataForm.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/generic_login/generic_login.component.ts